import * as Sentry from "@sentry/browser"

export const getParameterByName = (name: string, urlInput?: string | null): string | null => {
  const url = urlInput ?? window.location.href
  name = name.replace(/[[\]]/g, "\\$&")
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url)
  if (!results) {
    return null
  }
  if (!results[2]) {
    return ""
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "))
}

export const containsPathInURL = (path: string): boolean => {
  const { pathname } = window.location

  return pathname.includes(path)
}

export const removePathInUrl = (pathToRemove: string): void => {
  const currentUrl = window.location.href
  const newUrl = currentUrl.replace(pathToRemove, "")

  window.history.replaceState({}, document.title, newUrl)
}

/**
 * Removes URL parameters
 *
 * @param removeParams - param array
 */
export const removeURLParameters = (removeParams: string[]): void => {
  const deleteRegex = new RegExp(removeParams.join("=|") + "=")

  const params = location.search.slice(1).split("&")
  const search = []
  for (const param of params) {
    if (deleteRegex.test(param) === false) {
      search.push(param)
    }
  }

  const queryString = search.length ? search.join("&") : null

  window.history.replaceState(
    {},
    document.title,
    location.pathname + (queryString ? "?" + queryString : "") + location.hash,
  )
}

export const getCookie = (cname: string): string | null => {
  const name = cname + "="
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(";")
  for (let c of ca) {
    while (c.charAt(0) === " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

// normal JSON.parse will fail horribly if given something that isn't valid JSON
// This instead will return `null` and report everything to sentry
export const parseJsonOrTellSentry = <T>(errorTag: string, hopefullyJsonString: string | null): T | null => {
  try {
    return hopefullyJsonString ? JSON.parse(hopefullyJsonString) : null
  } catch (parsingError) {
    const error = new Error(
      `Error parsing JSON value for ${errorTag}.  Attempted to parse the following value: ${hopefullyJsonString}`,
    )
    Sentry.captureException(error)
    return null
  }
}

export const debugLogInDev = (message: string | Error, ...extras: unknown[]): void => {
  if (IS_DEVELOPMENT) {
    if (message instanceof Error) {
      return void console.error(message)
    }

    return void console.log(message, ...extras)
  }
}

export const neverThrow = <Fn extends (...args: any[]) => unknown>(fn: Fn): ReturnType<Fn> | undefined => {
  try {
    const res = fn() as ReturnType<Fn>
    return res
  } catch (e) {
    Sentry.captureException(e)
  }

  return undefined
}
